import React from 'react';
import { EstimateLineItem, Vehicle } from '../../types';
import ServiceItemsTable from '../ServiceItemsTable';

export interface EstimateLineItemsProps {
  estimateId?: number;
  items: EstimateLineItem[];
  isMobile: boolean; // kept for call-site compatibility; renderer detects width internally
  isLocked: boolean;
  onItemsChange: (items: EstimateLineItem[]) => void;
  taxRate?: number;
  vehicle?: Vehicle;
}

/**
 * Estimate line-item editor. Single responsive renderer (ServiceItemsTable) at
 * all widths — never swaps component identity, so in-progress edits survive
 * viewport resize / rotation. Operates on the in-memory items array; the
 * estimate persists the whole array on save.
 */
export const EstimateLineItems: React.FC<EstimateLineItemsProps> = ({
  items,
  isLocked,
  onItemsChange,
  taxRate,
  vehicle,
}) => (
  <ServiceItemsTable
    items={items}
    onChange={onItemsChange}
    disabled={isLocked}
    taxRate={taxRate}
    vehicle={vehicle}
  />
);
